import { Typography } from "@mui/material";
import React from "react";
import { Box } from "@mui/system"; // Correct import

const CustomNoRowsOverlay = () => {
  return(
  <Box className="w-full flex items-center flex-col justify-center h-[80px] text-center">
    <Typography variant="body2" className="text-gray-500">
      No records to display
    </Typography>
  </Box>
  )
};

export default CustomNoRowsOverlay;
